import request from '@/plugin/axios';

export function getAttendPlanInfoList(params) {
  return request({
    url: '/baseApi/plan/getAttendPlanInfoList',
    method: 'get',
    params
  });
}

export function getAttendBrokenLine(params) {
  return request({
    url: '/attendanceApi/attend/student/getAttendBrokenLine',
    method: 'get',
    params
  });
}

export function getAttendClassListByPage(params) {
  return request({
    url: '/attendanceApi/attend/student/getAttendClassListByPage',
    method: 'get',
    params
  });
}

export function getAttendBrokenLineForTeacher(params) {
  return request({
    url: '/attendanceApi/attend/teacher/getAttendBrokenLine',
    method: 'get',
    params
  });
}

export function getAttendTeacherListByPage(params) {
  return request({
    url: '/attendanceApi/attend/teacher/getAttendSummary',
    method: 'get',
    params
  });
}

export function getClassByUser(params) {
  return request({
    url: '/baseApi/class/getClassByUser',
    method: 'get',
    params
  });
}

export function getAttendFeatureImgList(params) {
  return request({
    url: '/attendanceApi/attend/student/getAttendFeatureImgList',
    method: 'get',
    params
  });
}

export function getAttendStudentListByPage(params) {
  return request({
    url: '/attendanceApi/attend/student/getAttendStudentListByPage',
    method: 'get',
    params
  });
}

export function getTimeSlotBrokenLine(params) {
  return request({
    url: '/attendanceApi/attend/student/getTimeSlotBrokenLine',
    method: 'get',
    params
  });
}

export function getStudentListForCheck(params) {
  return request({
    url: '/baseApi/student/getStudentList',
    method: 'get',
    params
  });
}

export function getTeacherListForCheck(params) {
  return request({
    url: '/baseApi/teacher/getTeacherList',
    method: 'get',
    params
  });
}

export function getGradeClassListForCheck(params) {
  return request({
    url: '/baseApi/class/getGradeClassListByAttend',
    method: 'get',
    params
  });
}
